import React, { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import MyPagination from 'components/ui/MyPagination'
import MyRefetchButton from 'components/ui/MyRefetchButton'
import { ContentTagFilter } from 'components/template-tags'
import { useDlcFramesForm } from './formStore'

const FilterLabel = ({ htmlFor, children }) => (
  <label htmlFor={htmlFor} className="shrink-0 text-sm font-medium">
    {children}
  </label>
)

const DataTableToolbar = ({ mutate, nextAfter }) => {
  const [, setSearchParams] = useSearchParams()
  const contentTag = useDlcFramesForm((s) => s.contentTag)
  const setContentTagStore = useDlcFramesForm((s) => s.setContentTag)
  const afters = useDlcFramesForm((s) => s.afters)
  const after = useDlcFramesForm((s) => s.after)
  const goAfter = useDlcFramesForm((s) => s.goAfter)

  const setContentTag = useCallback(
    (value) => {
      const next = value || null
      setContentTagStore(next)
      setSearchParams(
        (prev) => {
          const params = new URLSearchParams(prev)
          if (next) params.set('contentTag', next)
          else params.delete('contentTag')
          return params
        },
        { replace: true },
      )
    },
    [setContentTagStore, setSearchParams],
  )

  return (
    <div className="mb-2 flex w-full flex-wrap items-center gap-x-4 gap-y-2">
      <MyPagination
        nextAfter={nextAfter}
        after={after}
        goAfter={goAfter}
        afters={afters}
      />
      <MyRefetchButton onClick={() => mutate()} />
      <div className="flex items-center gap-2">
        <FilterLabel htmlFor="dlc-contentTag">Tag:</FilterLabel>
        <ContentTagFilter
          id="dlc-contentTag"
          value={contentTag}
          onChange={setContentTag}
        />
      </div>
    </div>
  )
}

export default DataTableToolbar
